import {Directive, Input} from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[barcodeMaximumAmount]',
  providers: [{ provide: NG_VALIDATORS, useExisting: BarcodeMaximumAmountDirective, multi: true }]
})
export class BarcodeMaximumAmountDirective {
  @Input('barcodeMaximumAmount') barcodeMax: number;
  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.barcodeMaximumAmountValidator(this.barcodeMax)(control);
  }

}
